import React, { useCallback } from 'react';
import Flickity from 'react-flickity-component';
import styles from './Tabs.module.scss';
import 'flickity/css/flickity.css';

type Props = {
  tabs: Record<string, string>;
  selectedTab: string;
  setSelectedTab: (index: string) => void;
};
const Tabs: React.FC<Props> = ({ tabs, selectedTab, setSelectedTab }) => {
  const onClick = useCallback(
    (tab: string) => {
      return () => setSelectedTab(tab);
    },
    [setSelectedTab]
  );

  return (
    <Flickity
      options={{
        initialIndex: 0,
        accessibility: true,
        pageDots: false,
        cellAlign: 'left',
        groupCells: '80%'
      }}
      className={styles.carousel}
    >
      {Object.keys(tabs).map((tab) => (
        <button
          type="button"
          className={`${styles.carouselCell} ${tab === selectedTab ? `${styles.active}` : ''}`}
          key={tab}
          onClick={onClick(tab)}
        >
          {tabs[tab]}
        </button>
      ))}
    </Flickity>
  );
};

export default Tabs;
